import type { ScheduleEventData } from '@mantine/schedule';
import dayjs from 'dayjs';
import type { PayloadType } from '../../types';

export const getEventsCountByDay = (
  events: ScheduleEventData<PayloadType>[]
): Record<string, number> => {
  const result: Record<string, number> = {};

  for (const event of events) {
    const start = dayjs(event.start).startOf('day');
    const end = dayjs(event.end).subtract(1, 'second').startOf('day');

    let current = start;
    while (!current.isAfter(end)) {
      const day = current.format('YYYY-MM-DD');
      result[day] = (result[day] ?? 0) + 1;
      current = current.add(1, 'day');
    }
  }

  return result;
};
